import { FC } from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'

interface SignalCardProps {
  title: string
  attributeCount: number
  description: string
  color: string
}

export const SignalCard:FC<SignalCardProps> = ({title, attributeCount, description, color}) => {
  const theme = useTheme()
  return (
    <Stack direction="row">
      <Box sx={{p:'4px'}}>
        <Box sx={{width:24, height:24, background: color, borderRadius:1}} />
      </Box>
      <Stack sx={{p:'4px', fontSize:'0.85rem'}}>
        <Typography sx={{fontSize:'inherit'}}>{title}</Typography>
        <Typography sx={{fontWeight:theme.typography.fontWeightMedium, fontSize:'inherit'}}>{attributeCount} Attributes</Typography>
        <Typography sx={{fontSize:'inherit'}}>{description}</Typography>
      </Stack>

    </Stack>
  )
}